var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "chat-initiator-template" },
    [
      _c("div", { staticClass: "header" }, [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("whatsapp_business_api.chatInitiatorTemplate"))),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "title" }, [
        _vm._v(
          _vm._s(_vm.$t("whatsapp_business_api.selectChatInitiatorTemplate"))
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex gap-5" },
        [
          _c(
            "a-select",
            {
              staticStyle: { width: "100%" },
              attrs: {
                placeholder: _vm.$t(
                  "whatsapp_business_api.selectChatInitiatorTemplate"
                ),
              },
              model: {
                value: _vm.selectedTemplateId,
                callback: function ($$v) {
                  _vm.selectedTemplateId = $$v
                },
                expression: "selectedTemplateId",
              },
            },
            _vm._l(_vm.templates, function (template) {
              return _c(
                "a-select-option",
                { key: template.id, attrs: { value: template.id } },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(template.elementName) +
                      "\n            "
                  ),
                ]
              )
            }),
            1
          ),
          _vm._v(" "),
          _vm.loading
            ? _c(
                "a-spin",
                [
                  _c("a-icon", {
                    staticStyle: { "font-size": "24px" },
                    attrs: { slot: "indicator", type: "loading", spin: "" },
                    slot: "indicator",
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("a-divider"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "start-template-viewer" },
        [
          !!_vm.selectedTemplate
            ? _c("TemplateCard", { attrs: { template: _vm.selectedTemplate } })
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "right" }, [
            _c(
              "div",
              { staticClass: "preview-container" },
              [
                _vm.selectedTemplate
                  ? _c("WhatsappMessagePreview", {
                      attrs: {
                        body: _vm.getTemplateParameters(_vm.selectedTemplate)
                          .body,
                        footer: _vm.getTemplateParameters(_vm.selectedTemplate)
                          .footer,
                        headerType: _vm.getTemplateParameters(
                          _vm.selectedTemplate
                        ).headerText,
                        "header-text": _vm.getTemplateParameters(
                          _vm.selectedTemplate
                        ).headerText,
                        buttons: _vm.getTemplateParameters(_vm.selectedTemplate)
                          .buttons,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }